import { useSelector } from 'react-redux';

import { RootState } from '../types';
import { ASSET_TOKEN_TYPE } from '../types';

export const useCheckBalanceHook = () => {
  const balance = useSelector((state: RootState) => state.balance);

  const getTokenNameValue = (
    tokenType: ASSET_TOKEN_TYPE,
    tokenName: string
  ) => {
    const tokenMappedName =
      tokenType === 'HYBRID' ? 'hybridTokens' : 'simpleTokens';
    return balance.data.info?.simpleTokens[tokenMappedName] ?? 0;
  };

  const checkTokenBalance = (
    tokenType: ASSET_TOKEN_TYPE,
    tokenName: string,
    value: number
  ) => {
    const tokenValue = getTokenNameValue(tokenType, tokenName);
    return value < tokenValue;
  };

  const getTokenTotalValue = (tokenType: ASSET_TOKEN_TYPE) => {
    const mappedName =
      tokenType === 'HYBRID' ? 'hybridValue' : 'simpleTokenValue';
    if (balance.data.info) {
      return balance.data.info[mappedName];
    }

    return 0;
  };

  return { balance, checkTokenBalance, getTokenNameValue, getTokenTotalValue };
};
